import { j as r, c as f } from "../../utils-BdNIfrGQ.js";
import * as G from "react";
import u from "react";
import { u as b, P as x, c as V, a as $ } from "../../index-wif4gfZf.js";
import { c as E } from "../../index-Di82Y7n3.js";
import { T as M } from "../../Text-BhLXzYEf.js";
import { S as A } from "../../skeleton-CpjuZTJp.js";
import { I as F, c as C, R as D } from "../../index-aU3BIiYl.js";
import { u as B } from "../../index-fVZ4qWjb.js";
var _ = "Toggle", h = G.forwardRef((e, t) => {
  const { pressed: a, defaultPressed: o, onPressedChange: n, ...s } = e, [i, l] = b({
    prop: a,
    onChange: n,
    defaultProp: o ?? !1,
    caller: _
  });
  return /* @__PURE__ */ r.jsx(
    x.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...s,
      ref: t,
      onClick: V(e.onClick, () => {
        e.disabled || l(!i);
      })
    }
  );
});
h.displayName = _;
var O = h;
const T = E(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-border bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-10 py-2 w-full px-7",
        sm: "h-fit py-3 px-5 w-fit",
        lg: "h-11 px-8 text-lg"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function H({
  className: e,
  variant: t,
  size: a,
  ...o
}) {
  return /* @__PURE__ */ r.jsx(
    O,
    {
      "data-slot": "toggle",
      className: f(T({ variant: t, size: a, className: e })),
      ...o
    }
  );
}
const le = ({ ...e }) => /* @__PURE__ */ r.jsx(H, { ...e }), L = ({
  variant: e,
  size: t,
  className: a,
  ...o
}) => /* @__PURE__ */ r.jsx(
  A,
  {
    className: f(T({ variant: e, size: t }), "w-[80px] h-[40px] block", a),
    ...o,
    children: /* @__PURE__ */ r.jsx(M, {})
  }
);
L.displayName = "ToggleSkeleton";
var c = "ToggleGroup", [I] = $(c, [
  C
]), w = C(), j = u.forwardRef((e, t) => {
  const { type: a, ...o } = e;
  if (a === "single") {
    const n = o;
    return /* @__PURE__ */ r.jsx(U, { ...n, ref: t });
  }
  if (a === "multiple") {
    const n = o;
    return /* @__PURE__ */ r.jsx(q, { ...n, ref: t });
  }
  throw new Error(`Missing prop \`type\` expected on \`${c}\``);
});
j.displayName = c;
var [y, R] = I(c), U = u.forwardRef((e, t) => {
  const {
    value: a,
    defaultValue: o,
    onValueChange: n = () => {
    },
    ...s
  } = e, [i, l] = b({
    prop: a,
    defaultProp: o ?? "",
    onChange: n,
    caller: c
  });
  return /* @__PURE__ */ r.jsx(
    y,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: u.useMemo(() => i ? [i] : [], [i]),
      onItemActivate: l,
      onItemDeactivate: u.useCallback(() => l(""), [l]),
      children: /* @__PURE__ */ r.jsx(k, { ...s, ref: t })
    }
  );
}), q = u.forwardRef((e, t) => {
  const {
    value: a,
    defaultValue: o,
    onValueChange: n = () => {
    },
    ...s
  } = e, [i, l] = b({
    prop: a,
    defaultProp: o ?? [],
    onChange: n,
    caller: c
  }), g = u.useCallback(
    (d) => l((p = []) => [...p, d]),
    [l]
  ), m = u.useCallback(
    (d) => l((p = []) => p.filter((z) => z !== d)),
    [l]
  );
  return /* @__PURE__ */ r.jsx(
    y,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: g,
      onItemDeactivate: m,
      children: /* @__PURE__ */ r.jsx(k, { ...s, ref: t })
    }
  );
});
j.displayName = c;
var [J, K] = I(c), k = u.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: a,
      disabled: o = !1,
      rovingFocus: n = !0,
      orientation: s,
      dir: i,
      loop: l = !0,
      ...g
    } = e, m = w(a), d = B(i), p = { role: "group", dir: d, ...g };
    return /* @__PURE__ */ r.jsx(J, { scope: a, rovingFocus: n, disabled: o, children: n ? /* @__PURE__ */ r.jsx(
      D,
      {
        asChild: !0,
        ...m,
        orientation: s,
        dir: d,
        loop: l,
        children: /* @__PURE__ */ r.jsx(x.div, { ...p, ref: t })
      }
    ) : /* @__PURE__ */ r.jsx(x.div, { ...p, ref: t }) });
  }
), v = "ToggleGroupItem", N = u.forwardRef(
  (e, t) => {
    const a = R(v, e.__scopeToggleGroup), o = K(v, e.__scopeToggleGroup), n = w(e.__scopeToggleGroup), s = a.value.includes(e.value), i = o.disabled || e.disabled, l = { ...e, pressed: s, disabled: i }, g = u.useRef(null);
    return o.rovingFocus ? /* @__PURE__ */ r.jsx(
      F,
      {
        asChild: !0,
        ...n,
        focusable: !i,
        active: s,
        ref: g,
        children: /* @__PURE__ */ r.jsx(P, { ...l, ref: t })
      }
    ) : /* @__PURE__ */ r.jsx(P, { ...l, ref: t });
  }
);
N.displayName = v;
var P = u.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: a, value: o, ...n } = e, s = R(v, a), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, l = s.type === "single" ? i : void 0;
    return /* @__PURE__ */ r.jsx(
      h,
      {
        ...l,
        ...n,
        ref: t,
        onPressedChange: (g) => {
          g ? s.onItemActivate(o) : s.onItemDeactivate(o);
        }
      }
    );
  }
), Q = j, W = N;
const S = G.createContext({
  size: "default",
  variant: "default",
  spacing: 0
});
function X({
  className: e,
  variant: t,
  size: a,
  spacing: o = 0,
  children: n,
  ...s
}) {
  return /* @__PURE__ */ r.jsx(
    Q,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": a,
      "data-spacing": o,
      style: { "--gap": o },
      className: f(
        "group/toggle-group flex w-fit items-center gap-[--spacing(var(--gap))] rounded-md data-[spacing=default]:data-[variant=outline]:shadow-xs",
        e
      ),
      ...s,
      children: /* @__PURE__ */ r.jsx(S.Provider, { value: { variant: t, size: a, spacing: o }, children: n })
    }
  );
}
function Y({
  className: e,
  children: t,
  variant: a,
  size: o,
  ...n
}) {
  const s = G.useContext(S);
  return /* @__PURE__ */ r.jsx(
    W,
    {
      "data-slot": "toggle-group-item",
      "data-variant": s.variant || a,
      "data-size": s.size || o,
      "data-spacing": s.spacing,
      className: f(
        T({
          variant: s.variant || a,
          size: s.size || o
        }),
        "w-auto min-w-0 shrink-0 focus:z-10 focus-visible:z-10",
        "data-[spacing=0]:rounded-none data-[spacing=0]:shadow-none data-[spacing=0]:first:rounded-l-md data-[spacing=0]:last:rounded-r-md data-[spacing=0]:data-[variant=outline]:border-l-0 data-[spacing=0]:data-[variant=outline]:first:border-l",
        e
      ),
      ...n,
      children: t
    }
  );
}
const ie = ({
  ...e
}) => /* @__PURE__ */ r.jsx(X, { ...e }), ue = ({
  ...e
}) => /* @__PURE__ */ r.jsx(Y, { ...e });
export {
  le as Toggle,
  ie as ToggleGroup,
  ue as ToggleGroupItem,
  L as ToggleSkeleton
};
